import axios from "axios";

// Use the page's own origin for the API base — Emergent routes /api/* on every
// domain (preview, production, and custom domains like correlate.online) to
// the backend. Hardcoding REACT_APP_BACKEND_URL here would make API calls from
// a custom domain cross-origin, and the auth cookie set by the backend would
// then be a THIRD-PARTY cookie from the page's perspective — modern browsers
// (especially Android Chrome in PWA standalone mode) block these aggressively,
// silently breaking Google Login and all session persistence.
// The `typeof window` guard is purely defensive: CRA only runs in the browser,
// so the env-var branch is effectively never hit at runtime — it exists so the
// module is safe to import from tests or any future SSR/build-time tooling.
const BACKEND_URL =
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Cookies (httpOnly) carry auth. `withCredentials` ensures the browser sends them.
// We intentionally do NOT store the JWT in localStorage — it would be readable by any XSS.
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  // CSRF defense: a custom request header the backend requires on all
  // state-changing calls. Browsers cannot send custom headers cross-origin
  // without a passing CORS preflight, and our allowlist rejects foreign
  // origins on preflight — so a page on evil.com cannot forge writes even
  // if it steals the SameSite=None session cookie. See backend core/csrf.py.
  headers: { "X-Correlate-Client": "web" },
});
